document.addEventListener('DOMContentLoaded', async function () {
  const ua = navigator.userAgent.toLowerCase();
  const isMedianApp = ua.includes('median');

  if (!isMedianApp) return;

  console.log('Median app detected');

  // 1. Save app source in cart attributes
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          Order_Source: 'Mobile App'
        }
      })
    });

    const cart = await response.json();
    console.log('Cart attribute saved:', cart.attributes);

  } catch (error) {
    console.error('Cart attribute error:', error);
  }

  // 2. Apply app-only discount
  if (!sessionStorage.getItem('welcomeapp_discount_applied')) {
    sessionStorage.setItem(
      'welcomeapp_discount_applied',
      'true'
    );

    const currentPath =
      window.location.pathname +
      window.location.search;

    window.location.replace(
      '/discount/WELCOMEAPP?redirect=' +
      encodeURIComponent(currentPath)
    );
  }
});